import React from 'react';
import { Card } from '@douyinfe/semi-ui';
import { useDrag } from 'react-dnd';
import { MODULE_TYPES } from './moduleTypes';

const ModulePreview = ({ type }) => {
    const moduleConfig = MODULE_TYPES[type];
    if (!moduleConfig || !moduleConfig.preview) return null;

    const { preview } = moduleConfig;

    const renderPreviewItems = (items) => {
        return items.map((item, index) => (
            <div key={index} style={item.style} />
        ));
    };

    return (
        <div style={preview.style}>
            {preview.avatar && <div style={preview.avatar.style} />}
            {preview.content && (
                <div style={preview.content.style}>
                    {preview.content.title && <div style={preview.content.title.style} />}
                    {preview.content.description && <div style={preview.content.description.style} />}
                </div>
            )}
            {preview.button && <div style={preview.button.style} />}
            {preview.items && renderPreviewItems(preview.items)}
        </div>
    );
}

const H5Module = ({ type, title, preview, onDrop }) => {
    const [{ isDragging }, drag] = useDrag(() => ({
        type: 'H5_MODULE',
        item: { type, title },
        collect: (monitor) => ({
            isDragging: monitor.isDragging()
        })
    }));

    const handleDoubleClick = () => {
        if (onDrop) {
            onDrop({ type, title });
        }
    };

    return (
        <div
            ref={drag}
            style={{
                opacity: isDragging ? 0.5 : 1,
                cursor: 'move'
            }}
            onDoubleClick={handleDoubleClick}
        >
            <Card size="small" bodyStyle={{ padding: 0 }}>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <div style={{ textAlign: 'center', borderBottom: '1px solid var(--semi-color-border)', fontSize: '12px', fontWeight: 'bold' }}>
                        {title}
                    </div>
                    <div style={{ minHeight: '40px', padding: '4px' }}>
                        {preview || <ModulePreview type={type} />}
                    </div>
                </div>
            </Card>
        </div >
    );
};

export default H5Module;